import { initializeApp } from 'firebase/app';
import { doc, initializeFirestore, getFirestore, onSnapshot, query } from 'firebase/firestore';

import config from '../../client-config';

export const app = initializeApp(config);
config.firestore && initializeFirestore(app, config.firestore);

export { doc, getFirestore, onSnapshot, query };
